//  Modules from the React eco-system
import { useState, useEffect } from "react"

// Own components
import SubPageNavbar from "../components/navigation/subpage-navbar.component"
import Loader from "../components/loader.component"

// Navigation
import operatorsMainRoutes from "../routes/mains/operators-main.route"
import { Route, Switch, useHistory } from "react-router-dom"

// Axios
import axiosClient from "../api/api"

// Redux
import { setPageName } from "../store/pageSlice"
import { useDispatch } from "react-redux"

// Interfaces, enums
import { IOperator } from "../interfaces/persons"
import { ISubPageRoute } from "../interfaces/pages"

function Operators() {
    const dispatch = useDispatch()
    const history = useHistory()

    const [operators, setOperators] = useState<IOperator[]>([])

    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        dispatch(setPageName({ pageName: "Operators", pageUrl: "/admin/operators/main", subPageName: "" }))
        fetchOperators()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    async function fetchOperators() {
        setIsLoading(true)
        try {
            const response = await axiosClient.get("/operator")
            setOperators(response.data)
        } catch (error) {
            console.log("Failed to fetch operators")
            history.push("/admin/404")
        }
        setIsLoading(false)
    }

    return (
        <div>
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <SubPageNavbar routes={operatorsMainRoutes} />

                    <Switch>
                        {operatorsMainRoutes.map((route: ISubPageRoute, key: number) => {
                            return (
                                <Route
                                    key={key}
                                    path={route.path}
                                    exact
                                    render={() => {
                                        return (
                                            <div>
                                                <route.component operators={operators} setOperators={setOperators} {...route.props} />
                                            </div>
                                        )
                                    }}
                                />
                            )
                        })}
                    </Switch>
                </>
            )}
        </div>
    )
}

export default Operators
